import React from 'react';
import { IServicetjekEvent } from './ServicetjekLivshaendelse.definition';
import { MessageLinkList } from '@Components/ServiceTjek/MessageLinkList/MessageLinkList';
import AccordionTabList from '@Components/accordion/components/accordionTabList';
import MessageLinks from '@Components/ServiceTjek/MessageLinkList';

const ServicetjekLivshaendelse = (props: IServicetjekEvent) => {
	const {
		overskrift,
		manchet,
		billede,
		fokusOverskrift,
		meddelelserIFokus,
		udenforFokusOverskrift,
		meddelelserUdenforFokus,
		accordionOverskrift,
		accordionsList,
		ctaOverskrift,
		ctaManchet,
		ctaBillede,
		ctaKnaptekst,
		ctaLink,
		loginUrl,
		loginKnapTekst,
		loginOverskrift,
		loginManchet
	} = props;

	const isLoggedIn = !loginUrl;

	const renderEventHero = () => (
		<div className="f-grid event-hero">
			<div className="col-sm-6 col-md-5 col-lg-5">
				{ overskrift &&
				<h1 className="mb-2 text-xl responsive font-semibold color-primary">{ overskrift }</h1> }
				{ manchet &&
				<p className="mb-2" dangerouslySetInnerHTML={ { __html: manchet } } /> }

				{ isLoggedIn &&
					<MessageLinkList overskrift={ fokusOverskrift } meddelelser={ meddelelserIFokus } /> }

				{ !isLoggedIn && (
					<>
						{ loginOverskrift &&
					<p><strong>{ loginOverskrift }</strong></p> }
						{ loginManchet &&
					<p className="mb-2" dangerouslySetInnerHTML={ { __html: loginManchet } } /> }
						{ loginUrl &&
					<a href={ loginUrl } className="button button--liv mb-1">{ loginKnapTekst }</a> }
					</>
				) }
			</div>
			<div className="col-sm-6 col-md-5 col-lg-5 col-sm-shift-0 col-md-shift-2 col-lg-shift-2">
				{ billede &&
				<img src={ billede.url } alt={ billede.alt } /> }
			</div>
		</div>
	);

	const renderAccordions = () => (
		<div className="f-grid">
			<AccordionTabList overskrift={ accordionOverskrift } accordionTabList={ accordionsList } />
		</div>
	);

	const renderCTA = () => (
		<div className="f-grid cta">
			<div className="col-sm-6 col-md-5 col-lg-5 d-flex align-items-center justify-content-center">
				{ ctaBillede && <img src={ ctaBillede.url } alt={ ctaBillede.alt } /> }
			</div>
			<div className="col-sm-6 col-md-5 col-lg-5 col-sm-shift-0 col-md-shift-2 col-lg-shift-2">
				<div className="center-vert">
					<div className="text-center">
						{ ctaOverskrift && <h3 className="text-lg font-semibold responsive color-primary">{ ctaOverskrift }</h3> }
						{ ctaManchet && <p className="text-lg mb-3 responsive">{ ctaManchet }</p> }
						{ ctaLink && <a href={ ctaLink } className="button button--liv mb-1">{ ctaKnaptekst }</a> }
					</div>
				</div>
			</div>
		</div>
	);

	return (
		<section className="servicetjek-livshaendelse">
			{ renderEventHero() }
			{ isLoggedIn && <MessageLinks overskrift={ udenforFokusOverskrift } meddelelser={ meddelelserUdenforFokus } /> }
			{ renderAccordions() }
			{ renderCTA() }
		</section>
	);
};

export default ServicetjekLivshaendelse;
